import React, { CSSProperties, FC, ReactNode } from 'react';
import { Card } from 'react-bootstrap';

import { Divider } from '../Divider';
import { Title } from '../Title';

const { Body } = Card;

interface IPanel {
  title?: string | ReactNode;
  headerComponent?: ReactNode;
  style?: CSSProperties;
  bodyStyle?: CSSProperties;
}

export const Panel: FC<IPanel> = ({ children, headerComponent, title, style, bodyStyle }) => (
  <Card style={style}>
    {title && (
      <>
        <Title>
          <span>{title}</span>
          {headerComponent}
        </Title>
        <Divider />
      </>
    )}
    <Body style={bodyStyle}>{children}</Body>
  </Card>
);
